import {
  Input,
  TextInput,
  PasswordInput,
  Checkbox,
  createTheme,
} from '@mantine/core';
import classes from './mantine.module.css';

export const mantineTheme = createTheme({
  components: {
    Input: Input.extend({
      classNames: {
        input: classes.input,
      },
    }),
    TextInput: TextInput.extend({
      styles: {
        error: {
          textAlign: 'left',
        },
      },
    }),
    PasswordInput: PasswordInput.extend({
      styles: {
        error: {
          textAlign: 'left',
        },
      },
    }),
    Checkbox: Checkbox.extend({
      styles: {
        input: {
          '&:checked': {
            backgroundColor: 'green',
            borderColor: 'green',
          },
        },
      },
    }),
  },
});
